export const RUNBOOK = {
  // dashboard
  dashboard: "runbook-dashboard",
  searchInput: "runbook-search-input",
  clearSearch: "runbook-clear-search",
  grid: "runbook-grid",
  card: (id) => `runbook-card-${id}`,
  cardTitle: (id) => `runbook-card-title-${id}`,
  createBtn: "runbook-create-btn",
  emptyState: "runbook-empty-state",
  errorState: "runbook-error-state",
  retryBtn: "runbook-retry-btn",
  resetFiltersBtn: "runbook-reset-filters-btn",
  loading: "runbook-loading",
  // sidebar filters
  categoryFilter: (c) => `filter-category-${c}`,
  severityFilter: (s) => `filter-severity-${s}`,
  envFilter: (e) => `filter-env-${e}`,
  // detail
  detail: "runbook-detail",
  editBtn: "runbook-edit-btn",
  deleteBtn: "runbook-delete-btn",
  backBtn: "runbook-back-btn",
  step: (i) => `runbook-step-${i}`,
  stepCheck: (i) => `runbook-step-check-${i}`,
  copyBtn: (i) => `runbook-copy-btn-${i}`,
  progressBar: "runbook-progress-bar",
  // outcome recorder
  outcomeStatus: "outcome-status-select",
  outcomeNotes: "outcome-notes-input",
  outcomeSubmit: "outcome-submit-btn",
  executionLog: "execution-log",
  // delete dialog
  deleteDialog: "delete-runbook-dialog",
  deleteConfirmInput: "delete-confirm-input",
  deleteConfirmBtn: "delete-confirm-btn",
  deleteCancelBtn: "delete-cancel-btn",
  // editor
  editorForm: "runbook-editor-form",
  fieldTitle: "editor-title",
  fieldCategory: "editor-category",
  fieldSeverity: "editor-severity",
  fieldEnvironment: "editor-environment",
  fieldSummary: "editor-summary",
  fieldTags: "editor-tags",
  fieldServices: "editor-services",
  fieldEstimated: "editor-estimated",
  addStepBtn: "editor-add-step",
  removeStepBtn: (i) => `editor-remove-step-${i}`,
  stepTitle: (i) => `editor-step-title-${i}`,
  stepDesc: (i) => `editor-step-desc-${i}`,
  stepCommand: (i) => `editor-step-command-${i}`,
  stepWarning: (i) => `editor-step-warning-${i}`,
  saveBtn: "editor-save-btn",
  cancelBtn: "editor-cancel-btn",
};

export const HEADER = {
  brand: "app-brand",
  themeToggle: "theme-toggle",
  userMenu: "user-menu",
  logoutBtn: "logout-btn",
  roleBadge: "role-badge",
  mobileMenu: "mobile-menu-btn",
  offlineBanner: "offline-banner",
};
